export const GET_USERS_SUCCESS = 'users/GET_USERS_SUCCESS';
export const GET_USERS_LOADING = 'users/GET_USERS_LOADING';
export const LOCK_USER_LOADING = 'users/LOCK_USER_LOADING';
export const LOCK_USER_SUCCESS = 'users/LOCK_USER_SUCCESS';
export const GET_USERS_FAILURE = 'users/GET_USERS_FAILURE';
export const GET_USERS_NOT_LOADING = 'users/GET_USERS_NOT_LOADING';
